<script>
/*
MIT License

Copyright (c) 2017 Luc

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.
*/
import katex from 'katex';
// Prevents PHPStorm from removing this when optimizing imports
// noinspection ES6UnusedImports
import * as mhchem from 'katex/contrib/mhchem/mhchem'; // eslint-disable-line import/namespace
import DOMPurify from 'dompurify';

export default {
  name: 'KatexElement',
  props: {
    expression: {
      type: String,
      default: '',
      required: true,
    },
    displayMode: {
      type: Boolean,
      default: false,
    },
    throwOnError: {
      type: Boolean,
      default: false,
    },
    errorColor: {
      type: String,
      default: '#cc0000',
    },
    macros: {
      type: Object,
      default: null,
    },
    colorIsTextColor: {
      type: Boolean,
      default: false,
    },
    maxSize: {
      type: Number,
      default: Infinity,
    },
    maxExpand: {
      type: Number,
      default: 1000,
    },
    allowedProtocols: {
      type: Array,
      default: () => ['http', 'https', 'mailto', '_relative'],
    },
    strict: {
      type: [Boolean, String, Function],
      default: 'warn',
    },
  },
  computed: {
    options() {
      return Object.assign(
        {},
        {
          displayMode: this.displayMode,
          throwOnError: this.throwOnError,
          errorColor: this.errorColor,
          macros: this.macros,
          colorIsTextColor: this.colorIsTextColor,
          maxSize: this.maxSize,
          maxExpand: this.maxExpand,
          allowedProtocols: this.allowedProtocols,
          strict: this.strict,
        }
      );
    },
    math() {
      return katex.renderToString(this.expression, this.options);
    },
  },
  render(h) {
    const element = this.displayMode ? 'div' : 'span';
    return h(element, {
      domProps: {
        innerHTML: DOMPurify.sanitize(this.math),
      },
    });
  },
};
</script>
